import {Component, Inject, Input, OnInit, PLATFORM_ID} from '@angular/core';
import {environment} from '../../_environments/environment';
import { isPlatformServer } from '@angular/common';

@Component({
    selector: 'app-image',
    templateUrl: './image.component.html',
    styleUrls: ['image.component.scss'],
    imports: []
})

export class ImageComponent {

  environment = environment;

  @Input() class = '';

  @Input() set size(value: string) {
    switch (value) {
      case 'sm':
        this.thumbmax = 1280;
        this.mediummax = 2000;
        this.largemax = 4000;
        break;
      case 'md':
        this.thumbmax = 200;
        this.mediummax = 3000;
        this.largemax = 5000;
        break;
      case 'lg':
        this.thumbmax = 200;
        this.mediummax = 350;
        this.largemax = 1280;
        break;
      default:
        this.thumbmax = 200;
        this.mediummax = 768;
        this.largemax = 1280;
        break;
    }

  }

  thumbmax = 200;
  mediummax = 768;
  largemax = 1280;


  @Input() src = '';
  @Input() alt = '';
  @Input() thumb = '';
  @Input() medium = '';
  @Input() large = '';

  @Input() set imageobject(obj: any) {
    if (obj) {
      let medium = ""
      if (obj['websitethumbimageurl']) {
        this.thumb = obj.websitethumbimageurl;
      }
      if (obj['thumburlpath']) {
        this.thumb = obj.thumburlpath;
      }

      if (obj['websitemediumimageurl']) {
        medium = obj['websitemediumimageurl']
        this.medium = this.setPlatformImage(obj.websitemediumimageurl, this.thumb)
      }
      if (obj['mediumurlpath']) {
        medium = obj['mediumurlpath']
        this.medium = this.setPlatformImage(obj.mediumurlpath, this.thumb)
      }

      if (obj['websitelargeimageurl']) {
        this.large = this.setPlatformImage(obj.websitelargeimageurl, medium)
      }
      if (obj['largeurlpath']) {
        this.large = this.setPlatformImage(obj.largeurlpath, medium)
      }

      if (obj['websiteimageurl']) {
        this.src = this.setPlatformImage(obj.websiteimageurl, medium)
      }
      if (obj['urlpath']) {
        this.src = this.setPlatformImage(obj.urlpath, medium)
      }
    }
  }

  fetchpriority = 'high'
  @Input() eager: boolean = true;

  @Input() height: number| string = '500'
  @Input() width: number| string = '750'

  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
  ) {
    this.fetchpriority = this.eager ? 'high': 'auto'; 
  }

  setPlatformImage(origImage: string, serverplatformImage): string{
    return isPlatformServer(this.platformId) && serverplatformImage? serverplatformImage: origImage;
  }


}
